module.exports = __webpack_public_path__ + "img/guanyu_mb.282b1f6a.png";